<template>
<div>

  <div class="dashboard">
  <div class="container-fluid">
          <div class="ml-2 mt-3 mb-2">
          Overview Dashboard
          </div>
    <div class="d-flex flex-row p-0 wbg mb-3 bshadow text-dark">

       <div class="card-body">
         <img class="card-img-top" src="../assets/images/Order.fw.png" alt="Card image"
          style="width:50px"> &nbsp; &nbsp;
          <b>Orders</b>
          <div class="ml-5 pl-4">
            <p v-if="totalorderscount != '' && totalorderscount != null">{{totalorderscount}}</p>
            <p v-if="totalorderscount =='' || totalorderscount == null">No Data</p>
          </div>
       </div>

     <span class="border border-left-0 border-bottom-0 border-top-0"></span>
       <div class="card-body"><img class="card-img-top" src="../assets/images/Payments.fw.png" alt="Card image"
        style="width:50px">&nbsp; &nbsp; Payments <div class="ml-5 pl-4" v-if="totalAmount !== '' && totalAmount !== null">
        ₹ {{totalAmount}}
        </div>
        <div class="ml-5 pl-4" v-if="totalAmount == '' || totalAmount == null">
        ₹ 0
        </div></div>
     <span class="border border-left-0 border-bottom-0 border-top-0"></span>
      <div class="card-body"><img class="card-img-top" src="../assets/images/product.fw.png" alt="Card image"
        style="width:50px">&nbsp; &nbsp; <b>Products</b>
        <div class="ml-5 pl-4">
          <p v-if="totalproducts != '' && totalproducts != null">{{totalproducts}}</p>
          <p v-if="totalproducts == '' || totalproducts  == null">No Data</p>
        </div>
      </div>
      <span class="border border-left-0 border-bottom-0 border-top-0"></span>
        <div class="card-body"><img class="card-img-top" src="../assets/images/Customers.fw.png" alt="Card image"
          style="width:50px">&nbsp; &nbsp;  <b>Customers</b>
          <div class="ml-5 pl-4">
            <p  v-if="totalcustomers!= '' && totalcustomers != null">{{totalcustomers}}</p>
            <p  v-else="totalcustomers =='' && totalcustomers == null">No Data</p>
          </div>
        </div>
      </div>
    </div>


  </div>


      </div>

  </div>
</div>
</template>

<script>
export default {
  name: 'member-dashboard',

  data() {
        return {
          totalorderscount: 0,
          totalAmount: 0,
          totalproducts: 0,
          totalcustomers: 0
        }
    },
    mounted() {
      this.totalorders(),
      this.gettotalamount(),
      this.gettotalproducts(),
      this.gettotalcustomers()
    },
  methods: {
    totalorders () {
      this.$http.get('/countt/totalorders-count/' + this.$route.params.mid).then((res) => {
        if (res.data.success === true) {
          this.totalorderscount = res.data.details[0].totalorderscount
        }
      })
    },
    gettotalamount () {
      this.$http.get('/countt/totalorders-amount/' + this.$route.params.mid).then((res) => {
        if(res.data.success === true) {
          this.totalAmount = res.data.details[0].totalorderamount
        }
      })
    },
    gettotalproducts () {
      this.$http.get('/countt/product-count/' + this.$route.params.mid).then((res) => {
        if (res.data.success === true) {
          this.totalproducts = res.data.details[0].productcount
        }
      })
    },
    gettotalcustomers () {
      this.$http.get('/countt/totalcustomer-count/' + this.$route.params.mid).then((res) => {
        if (res.data.success === true) {
          this.totalcustomers = res.data.details[0].totalcustomercount
        }
      })
    }

  }
}


</script>



// WEBPACK FOOTER //
// src/components/member-dashboard.vue